import { Component, OnInit } from '@angular/core';
import { AddApprovalSettingsComponent } from './add-approval-settings/add-approval-settings.component';
import { ApprovalFlow } from 'src/app/store/entities/instution-settings/approval-flow/approval-flow.model';
import { Observable } from 'rxjs';
import { SettingsService } from 'src/app/services/settings.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AppState } from 'src/app/store/reducers';
import { TranslateService } from '@ngx-translate/core';
import { Store, select } from '@ngrx/store';
import { getAllProcessApprovalFlows } from 'src/app/store/entities/instution-settings/approval-flow/approval-flow.actions';
import { selectModifiedApprovalFlows } from 'src/app/store/entities/instution-settings/approval-flow/approval-flow.selectors';
import { removeApprovalFlowMutation } from 'src/app/store/entities/instution-settings/approval-flow/approval-flow.actions';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-approval-flow-settings-list',
  templateUrl: './approval-flow-settings-list.component.html',
  styleUrls: ['./approval-flow-settings-list.component.scss']
})
export class ApprovalFlowSettingsListComponent implements OnInit {
  title: string;
  tableColumns: object;
  tableData: Observable<ApprovalFlow[]>;

  from: 'INST' | 'POPSM' = 'INST';

  constructor(
    private settingsService: SettingsService,
    private notificationService: NotificationService,
    private store: Store<AppState>,
    private route: ActivatedRoute
  ) {
    this.store.dispatch(getAllProcessApprovalFlows({filtering:{
      flowProcess:null,
      flowUniqueId:null
    }}))
  }

  ngOnInit(): void {
    this.title = 'Approval Flow';

    this.tableColumns = {
      no: 'SN',
      flowTitle: 'Flow Title',
      modFlowProcess:'Flow Process',
      actions: 'Actions',
    }

    this.from = this.route.snapshot.data['from']


    this.tableData = this.store.pipe(select(selectModifiedApprovalFlows))
  }


  addEditApprovalFlow(approvalFlow: ApprovalFlow = null): void {
    this.settingsService.openDialogModal({
      component: AddApprovalSettingsComponent,
      width: '50%',
      data: {
        approvalFlow,
        from: this.from
      }
    })
  }

  deleteApprovalFlow(approvalflow: ApprovalFlow): void {
    const message = 'Are you sure?';
      this.notificationService.confirmation(message, 'Delete').then((data) => {
        if(data.value){
          this.store.dispatch(removeApprovalFlowMutation({ flowUniqueId: approvalflow.flowUniqueId, id: approvalflow.id}));
        }
      })
  }

  deleteApprovalSuccessor(approvalflow: ApprovalFlow): void {
    const message = 'Are you sure?';
      this.notificationService.confirmation(message, 'Delete').then((data) => {
        if(data.value){
          this.store.dispatch(removeApprovalFlowMutation({ flowUniqueId: approvalflow.flowUniqueId, id: approvalflow.id}));
        }
      })
  }

}
